<mat-toolbar class="toolbar">
  <mat-divider [vertical]="true"></mat-divider>
  <img class="h-10 w-10"  src="assets/images/emblem.png">

  <div class="flex flex-col p-3">
    <span class="!text-[14px] !text-secondary-500">President’s Office Public Service Management and Good Governance</span>
    <span class="!font-bold !-mt-2">TGSD - TANZANIA GOVERNMENT SERVICE DIRECTORY</span>
  </div>

  <div class="flex w-full my-2 justify-end items-center">

<!--    <div class="border-2 text-sm border-white rounded-full p-1">-->
<!--      <div-->
<!--        class="flex items-center bg-white px-3 py-1 text-primary-500 rounded-full cursor-pointer"-->
<!--        *ngIf="activeLanguage == 'sw'"-->
<!--        (click)="onChangeLanguage('en')">-->
<!--        <span>EN</span>-->
<!--      </div>-->
<!--      <div-->
<!--        class="flex items-center bg-white px-3 py-1 text-primary-500 rounded-full cursor-pointer"-->
<!--        *ngIf="activeLanguage == 'en'"-->
<!--        (click)="onChangeLanguage('sw')">-->
<!--        <span>SW</span>-->
<!--      </div>-->
<!--    </div>-->

    <button (click)="notifications()" class="notifications" mat-icon-button style="margin-right: 10px">
      <app-font-awesome-icon matBadge="{{ totalUnreadNotification }}" matBadgeColor="warn" iconName="notification"></app-font-awesome-icon>
    </button>

    <div
      #t="matMenuTrigger"
      [matMenuTriggerFor]="menu"
      class="flex gap-1 items-center cursor-pointer rounded-full bg-gray-50/20 p-0.5">
      <span class="d-flex align-items-center user-icon">
        <mat-icon *ngIf="!photo; else pic" color="white"
                  svgIcon="person"></mat-icon>
        <ng-template #pic>
          <img *ngIf="!!photo" alt="P"
          class="rounded cursor-pointer text-center"
          [src]="photo"/>
        </ng-template>
      </span>
      <div class="flex flex-col">
        <span class="text-sm">{{ profile?.userFirstName }} {{ profile?.userLastName }}</span>
        <span class="text-xs" *ngIf="profile?.userEmail">{{ profile?.userEmail }}</span>
      </div>

      <div
        class="flex items-center justify-center">
        <mat-icon [class.open]="t.menuOpen" style="color: white !important" class="trigger-arrow !text-white" svgIcon="chevron-down">
        </mat-icon>
      </div>
    </div>

  </div>



  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/user-profile">
      <mat-icon svgIcon="person"></mat-icon>
      Profile
    </button>

    <button mat-menu-item routerLink="/change-password">
      <mat-icon svgIcon="password_key"></mat-icon>
      Change Password
    </button>
    <mat-divider class="gradient"></mat-divider>

    <mat-divider class="gradient"></mat-divider>
    <button (click)="logout()" mat-menu-item>
      <mat-icon svgIcon="logout"></mat-icon>
      Log Out
    </button>
  </mat-menu>
</mat-toolbar>

<!--{{profile | json }}-->
